export function initialize(module: ng.IModule) {
    module.directive("crewfileread", [crewfileread]);
}

export interface ICrewFileReadApi {
    click(); // Injected function
}

function crewfileread() {
    return {
        scope: {
            crewfileread: "=",
            directiveapi: "="
            
        },
        link: function (scope, elements, _attributes) {
            if (scope.directiveapi) {
                scope.directiveapi.click = () => elements[0].click();
            }
            elements.bind("change", function (changeEvent) {
                scope.crewfileread(changeEvent.target.files[0]);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/fileinput.directive.ts